// Create a simple Lorem Ipsum page

import { ContentDescriptionSchemaType } from '@lib/types/zod-schema'
import {
  Box,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
  Typography,
  Checkbox,
  Switch,
  Autocomplete,
  FormControl,
  FormHelperText,
} from '@mui/material'
import { type } from 'os'
import { useEffect, useState } from 'react'
import { Control, Controller, Form } from 'react-hook-form'

type OnlinePresence2FormProps = {
  control: Control<ContentDescriptionSchemaType, any>
}

const style = {
  form: {
    mb: 2,
  },
  alignment: {
    direction: 'column',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flex: 0.2,
    p: 2,
    width: '80%',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  checkbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  sub_alignment: {
    mt: 6,
    p: 2,
    display: 'flex',
    width: '50%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}

export function ContentDescription({ control }: OnlinePresence2FormProps) {
  const activities = [
    'Blogging',
    'Vlogging',
    'Podcast',
    'Long-form video',
    'Short-form video',
    'Photography',
    'Email newsletter',
    'Curation/Designer Picks',
    'Live events',
    'Live videos on social media',
  ]

  const contentTypes = [
    'Video',
    'Photo',
    'Case Studies',
    'Generative AI/Midjourney',
    'Email/Newsletter',
    'Blog',
  ]

  return (
    <>
      <Stack sx={style.alignment}>
        <Box sx={style.header}>
          <Typography variant="h4" component={'h2'} textAlign={'center'}>
            Describe the content you're looking for an influencer to create?
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 0.2,
            p: 2,
            width: '80%',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography
            fontWeight="bold"
            variant="h5"
            component="h3"
            textAlign={'center'}
          >
            What types of content do you want to create with brand partners?
            (Choose all that apply)
          </Typography>
          <Controller
            name="marketingActivities"
            control={control}
            render={({
              field: { value, onChange, onBlur, ref },
              fieldState: { error },
            }) => (
              <Autocomplete
                sx={{ p: 2 }}
                multiple
                onBlur={onBlur}
                options={activities}
                value={value}
                onChange={(event, value) => onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select"
                    error={Boolean(error)}
                    helperText={error ? error.message : null}
                  />
                )}
              />
            )}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flex: 0.2,
            p: 2,
            width: '80%',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography
            fontWeight="bold"
            variant="h5"
            component="h3"
            textAlign={'center'}
          >
            What type of content do you organically share?
          </Typography>
          <Controller
            name="content"
            control={control}
            render={({
              field: { value, onChange, onBlur, ref },
              fieldState: { error },
            }) => (
              <Autocomplete
                sx={{ p: 2 }}
                multiple
                onBlur={onBlur}
                options={contentTypes}
                value={value}
                onChange={(event, value) => onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select"
                    error={Boolean(error)}
                    helperText={error ? error.message : null}
                  />
                )}
              />
            )}
          />
        </Box>
        <Typography
          fontWeight="bold"
          variant="h5"
          component="h3"
          textAlign={'center'}
        >
          Do you work with a talent manager and/or production team?
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            mt: 3,
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Controller
            name="currentlyInAgency"
            control={control}
            render={({
              field: { value, onChange, onBlur, ref },
              fieldState: { error },
            }) => (
              <FormControlLabel
                control={
                  <Switch
                    id="currentlyInAgency"
                    color={value ? 'primary' : 'secondary'}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    onChange={onChange}
                    onBlur={onBlur}
                    checked={value}
                    inputRef={ref}
                  />
                }
                label={
                  <Typography variant="body2" component="p">
                    A marketing agency or outside representation handles my
                    content creation for me
                  </Typography>
                }
              />
            )}
          />

          <Controller
            name="inHouseContent"
            control={control}
            render={({
              field: { value, onChange, onBlur, ref },
              fieldState: { error },
            }) => (
              <FormControlLabel
                control={
                  <Switch
                    id="inHouseContent"
                    color={value ? 'primary' : 'secondary'}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    onChange={onChange}
                    onBlur={onBlur}
                    checked={value}
                    inputRef={ref}
                  />
                }
                label={
                  <Typography variant="body2" component="p">
                    Content is created in-house
                  </Typography>
                }
              />
            )}
          />
        </Box>
      </Stack>
    </>
  )
}
